import {
  getOxygenId,
  getCurrentToken,
  getCurrentTokenWithoutRedirect,
  fetchWithTokenAndRegion,
  getAdminConstructionApiUrl,
} from '@adsk/acs-sc-web-platform-api';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import {
  createDataStore,
  DataStore,
} from '../helpers/createDataModificationStore';
import { SubscriptionConstruction } from '../types';

export type SubscriptionConstructionStore =
  DataStore<SubscriptionConstructionResponse>;

type SubscriptionConstructionResponse = {
  results: SubscriptionConstruction[];
};

const fetchConstructionSubscriptions = async () => {
  await getCurrentTokenWithoutRedirect();
  const { accessToken } = await getCurrentToken();
  const oxygenId = getOxygenId(accessToken);
  return await fetchWithTokenAndRegion<SubscriptionConstructionResponse>(
    `${getAdminConstructionApiUrl()}/internal/v1/users/${oxygenId}/subscriptions?filter[status]=active,expired&filter[includeIsPurchasable]=true`,
  );
};

export const useSubscriptionsConstructionStore = () =>
  createDataStore<SubscriptionConstructionResponse>({
    contextName: CONTEXT_NAMES.SubscriptionsConstructionContext,
    fetchFunction: fetchConstructionSubscriptions,
  })();
